export function currentFrame(index: number, imgPath: string) {
  return require(`main/assets/images/${imgPath}${index
    .toString()
    .padStart(4, '0')}.webp`);
}
